import moment from 'moment'

const CACHEMAXLENGTH = 100;

const NotificationVuexModule = {
    namespaced: true,
    state: {
        notifications: []
    },
    getters: {
        unread: state => state.notifications.filter(n => !n.isRead)
    },
    mutations: {
        update: (state, update) => {
            state.notifications = update;
        }
    },
    actions: {
        logerror: (context, data) => {
            let notifs = context.state.notifications;
            if (notifs.length > CACHEMAXLENGTH) {
                notifs.pop();
            }

            let serialized = "";
            let isCustomError = false;
            if (typeof data.err == 'string' || data.err instanceof String) {
                serialized = data.err;
                isCustomError = true;
            } else {
                serialized = JSON.stringify(data.err);
            }

            let received = moment().toDate();
            let variant = 'danger';
            let notification = {
                message: serialized,
                receivedMinute: moment(received).format("hh:mm"),
                receivedISO: received.toISOString(),
                variant: variant,
                isRead: false
            }

            notifs.unshift(notification);

            context.commit('update', notifs);

            data.vm.$bvToast.toast(serialized, { title: 'Error', variant: variant });

            return !isCustomError;
        },
        notify: (context, data) => {
            let notifs = context.state.notifications;
            if (notifs.length > CACHEMAXLENGTH) {
                notifs.pop();
            }

            let serialized = "";
            if (typeof data.message == 'string' || data.message instanceof String) {
                serialized = data.message;
            } else {
                serialized = JSON.stringify(data.message);
            }

            let received = moment().toDate();
            let variant = 'info';
            let notification = {
                message: serialized,
                receivedMinute: moment(received).format("hh:mm"),
                receivedISO: received.toISOString(),
                variant: variant,
                isRead: false
            }

            notifs.unshift(notification);

            context.commit('update', notifs);

            data.vm.$bvToast.toast(serialized, { title: 'Notification', variant: variant });
        },
        markRead: context => {
            let notifs = context.state.notifications;
            for (const notification of notifs) {
                notification.isRead = true;
            }
            context.commit('update', notifs);
        },
    }
}

export default NotificationVuexModule
